import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import LazyImage from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import styled, { css } from "styled-components";

const enum fields {
    title = "title",
    image = "image",
    buttonTitle = "buttonTitle",
}

interface OwnProps extends WidgetProps {
    fields: {
        path1: LinkFieldValue;
        [fields.title]: string;
        [fields.image]: string;
        [fields.buttonTitle]: string;
    };
}

export interface FindBranchStyles {
    container?: GridContainerProps;
    linkStyle?: LinkPresentationProps;
    buttonWrapper?: InjectableCss;
    imageWrapper?: InjectableCss;
    linkWrapper?: InjectableCss;
    titleStyle?: InjectableCss;
}

export const findBranchStyles: FindBranchStyles = {
    container: {
        css: css`

        `,
    },
    buttonWrapper: {
        css: css`
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 100%;
        `,
    },
    imageWrapper: {
        css: css`
            img {
                height: 200px !important;
            }
        `,
    },
    linkStyle: {
        css: css`
            span {
                background-color: transparent !important;
                color: ${getColor("primary.main")} !important;
                font-size: 14px;
                font-weight: bold;
                line-height: normal;
                text-transform: uppercase;
                padding: 10px 0px;
            }
        `
    },
    linkWrapper: {
        css: css`
            background-color: ${getColor("primary.contrast")} !important;
            margin: 20px 55px 0px 55px;
        `
    },
    titleStyle: {
        css: css`
            font-size: 18px;
            font-weight: bold;
            text-transform: uppercase;
        `
    }
}

const Wrapper = styled.div<{}>`
    height: 100%;
    position: relative;
    text-align: center;
    color: white;
`;
const styles = findBranchStyles;

const FindBranch: React.FC<OwnProps> = ({ fields }) => {
    const { url } = useGetLink(fields.path1);
    return (
        <StyledWrapper>
            <Wrapper>
                <StyledWrapper {...styles.imageWrapper}>
                    <LazyImage src={fields.image} altText={fields?.title} />
                </StyledWrapper>
                <StyledWrapper {...styles.buttonWrapper}>
                    <Typography {...styles.titleStyle}>
                        {fields?.title}
                    </Typography>
                    <StyledWrapper {...styles.linkWrapper}>
                        <Link href={url} {...styles.linkStyle}>
                            {fields?.buttonTitle}
                        </Link>
                    </StyledWrapper>
                </StyledWrapper>
            </Wrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: FindBranch,
    definition: {
        group: "Basic",
        fieldDefinitions: [
            {
                name: fields.title,
                displayName: "Title",
                editorTemplate: "TextField",
                defaultValue: "",
                sortOrder: 0,
                fieldType: "Translatable",
            },
            {
                fieldType: "General",
                name: fields.image,
                displayName: "Image",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
            },
            {
                name: "path1",
                fieldType: "General",
                editorTemplate: "LinkField",
                defaultValue: { type: "Page", value: "" },
            },
            {
                name: fields.buttonTitle,
                displayName: "buttonTitle",
                editorTemplate: "TextField",
                defaultValue: "",
                sortOrder: 0,
                fieldType: "Translatable",
            },
        ],
    },
};

export default widgetModule;